/* eslint-disable import/prefer-default-export */
export const makeDate = (dateTimeString: string): Date => new Date(dateTimeString);
